import Parse from "parse";

import type { _User } from "./_User";
import type { OD3_Tenant } from "./OD3_Tenant";

export interface SIV_OrderAttributes {
  id: string;
  objectId: string;
  createdAt: Date;
  updatedAt: Date;
  appointedAt?: Date | undefined;
  appointedForByCustomer?: Date | undefined;
  commission?: string | undefined;
  cost_center?: string | undefined;
  country?: string | undefined;
  description?: string | undefined;
  email?: string | undefined;
  finishedAt?: Date | undefined;
  no: string;
  notFoundValues: any;
  processor?: _User | undefined;
  responsible?: _User | undefined;
  startedAt?: Date | undefined;
  tenant?: OD3_Tenant | undefined;
  type?: string | undefined;
}

export class SIV_Order extends Parse.Object<SIV_OrderAttributes> {
  static className: string = "SIV_Order";

  constructor(data?: Partial<SIV_OrderAttributes>) {
    super("SIV_Order", data as SIV_OrderAttributes);
  }

  get appointedAt(): Date | undefined {
    return super.get("appointedAt");
  }
  set appointedAt(value: Date | undefined) {
    super.set("appointedAt", value);
  }

  get appointedForByCustomer(): Date | undefined {
    return super.get("appointedForByCustomer");
  }
  set appointedForByCustomer(value: Date | undefined) {
    super.set("appointedForByCustomer", value);
  }

  get commission(): string | undefined {
    return super.get("commission");
  }
  set commission(value: string | undefined) {
    super.set("commission", value);
  }

  get cost_center(): string | undefined {
    return super.get("cost_center");
  }
  set cost_center(value: string | undefined) {
    super.set("cost_center", value);
  }

  get country(): string | undefined {
    return super.get("country");
  }
  set country(value: string | undefined) {
    super.set("country", value);
  }

  get description(): string | undefined {
    return super.get("description");
  }
  set description(value: string | undefined) {
    super.set("description", value);
  }

  get email(): string | undefined {
    return super.get("email");
  }
  set email(value: string | undefined) {
    super.set("email", value);
  }

  get finishedAt(): Date | undefined {
    return super.get("finishedAt");
  }
  set finishedAt(value: Date | undefined) {
    super.set("finishedAt", value);
  }

  get no(): string {
    return super.get("no");
  }
  set no(value: string) {
    super.set("no", value);
  }

  get notFoundValues(): any {
    return super.get("notFoundValues");
  }
  set notFoundValues(value: any) {
    super.set("notFoundValues", value);
  }

  get processor(): _User | undefined {
    return super.get("processor");
  }
  set processor(value: _User | undefined) {
    super.set("processor", value);
  }

  get responsible(): _User | undefined {
    return super.get("responsible");
  }
  set responsible(value: _User | undefined) {
    super.set("responsible", value);
  }

  get startedAt(): Date | undefined {
    return super.get("startedAt");
  }
  set startedAt(value: Date | undefined) {
    super.set("startedAt", value);
  }

  get tenant(): OD3_Tenant | undefined {
    return super.get("tenant");
  }
  set tenant(value: OD3_Tenant | undefined) {
    super.set("tenant", value);
  }

  get type(): string | undefined {
    return super.get("type");
  }
  set type(value: string | undefined) {
    super.set("type", value);
  }
}

Parse.Object.registerSubclass("SIV_Order", SIV_Order);
